export const translations = {
  fa: {
    meta: {
      siteName: 'سورنا آی‌تی (Sorena IT)',
      domain: 'sorena-it.ir',
      tagline: 'مرکز تخصصی طراحی وب‌سایت‌های پیشرفته، کدنویسی اختصاصی، وردپرس، تایپوتری و جوملا',
    },
    nav: {
      services: 'خدمات طراحی وب',
      campaign: 'کمپین تخفیف ۱۰۰ به ۳۰ م.',
      algoTrading: 'کدنویسی فارکس و الگو تریدینگ (MQ5 / Pine)',
      portfolio: 'نمونه‌کارها',
      techComparison: 'مقایسه تکنولوژی‌ها',
      calculator: 'محاسبه هزینه و زمان',
      seoCenter: 'استاندارد سئو و فایل‌ها',
      blog: 'وبلاگ و مقالات سئو',
      whyUs: 'چرا سورنا آی‌تی؟',
      faq: 'سوالات متداول',
      contact: 'ثبت سفارش و تماس',
      requestQuote: 'استعلام آنلاین قیمت',
      callUs: 'تماس با ما: (+98)9128634908',
    },
    hero: {
      badge: 'پایگاه فنی طراحی وب مدرن در ایران',
      title1: 'طراحی وب‌سایت اختصاصی و مدرن',
      title2: 'از کدنویسی تا وردپرس، تایپوتری و جوملا',
      description: 'سورنا آی‌تی (sorena-it.ir) مجری پروژه‌های پیشرفته وب با بهره‌گیری از جدیدترین فریم‌ورک‌های روز (React، Next.js، Node) و سیستم‌های مدیریت محتوای قدرتمند (WordPress، TYPO3، Joomla). تمرکز ما بر سرعت لودینگ زیر ۱ ثانیه، معماری کامل سئو و تجربه کاربری بی‌نقص است.',
      ctaPrimary: 'محاسبه آنلاین هزینه پروژه',
      ctaSecondary: 'مشاهده نمونه‌کارهای بین‌المللی',
      speedMetric: 'امتیاز Core Web Vitals',
      speedValue: '۱۰۰٪ فوق سریع',
      seoMetric: 'استاندارد سئو و اسکیمای گوگل',
      seoValue: 'رتبه ۱ تضمینی',
      satisfactionMetric: 'رضایت مشتریان و سازمان‌ها',
      satisfactionValue: '۹۹.۴٪ رضایت',
      techTickerTitle: 'پشتیبانی از انواع معماری‌ها و تکنولوژی‌های وب:',
    },
    services: {
      sectionBadge: 'خدمات تخصصی سورنا آی‌تی',
      title: 'اجرای انواع وب‌سایت با استانداردهای جهانی',
      subtitle: 'فرقی نمی‌کند نیاز شما یک سامانه کدنویسی شده اختصاصی باشد یا پورتال سازمانی با تایپوتری، فروشگاه وردپرسی یا جوملا؛ ما دقیق‌ترین راه‌حل را پیاده‌سازی می‌کنیم.',
      customTitle: 'برنامه‌نویسی و توسعه اختصاصی',
      customBadge: 'High Performance & Scale',
      customDesc: 'توسعه وب‌اپلیکیشن‌ها، پورتال‌ها و پلتفرم‌های مقیاس‌پذیر با React 19, Next.js, Node.js, Python و Tailwind CSS با کدنویسی تمیز و بدون وابستگی.',
      wordpressTitle: 'طراحی تخصصی با وردپرس و ووکامرس',
      wordpressBadge: 'Custom Themes & Speed',
      wordpressDesc: 'طراحی قالب‌های کاملاً اختصاصی (بدون قالب‌های سنگین آماده)، افزونه‌نویسی سفارشی، بهینه‌سازی سرعت و راه‌اندازی فروشگاه‌های اینترنتی قدرتمند.',
      typo3Title: 'توسعه پورتال‌های سازمانی با تایپو ۳ (TYPO3)',
      typo3Badge: 'Enterprise & Security',
      typo3Desc: 'پیاده‌سازی پورتال‌های عظیم چندزبانه برای دانشگاه‌ها، ارگان‌های دولتی، بانک‌ها و شرکت‌های چندملیتی با بالاترین سطح امنیت و سطوح دسترسی پیشرفته.',
      joomlaTitle: 'طراحی وب‌سایت‌های حرفه‌ای با جوملا (Joomla)',
      joomlaBadge: 'Robust CMS Architecture',
      joomlaDesc: 'توسعه سیستم‌های اطلاعاتی، دایرکتوری‌ها و پرتال‌های شرکتی بر بستر جدیدترین نگارش جوملا با ماژول‌نویسی اختصاصی و پایداری بالا.',
      seoTitle: 'سئو تکنیکال، ساختار Schema و نقشه سایت',
      seoBadge: 'Rank #1 Google Standards',
      seoDesc: 'تنظیم دقیق Robots.txt، ساخت Sitemap.xml با ساختار چندزبانه، نشانه‌گذاری‌های غنی Schema.org، برچسب‌های متادسکریپشن و بهینه‌سازی Alt تصاویر.',
      uiuxTitle: 'طراحی تجربه و رابط کاربری (UI/UX)',
      uiuxBadge: 'Human-Centered Design',
      uiuxDesc: 'طراحی پروتوتایپ‌های مدرن در فیگما بر اساس روانشناسی رفتار کاربر ایرانی و بین‌المللی، سازگار با موبایل، تبلت و دسکتاپ.',
      viewDetails: 'مشاهده مشخصات فنی و نمونه‌ها',
    },
    portfolio: {
      sectionBadge: 'نمونه کارهای بین‌المللی و ایرانی',
      title: 'ویترین پروژه‌های طراحی شده به زبان انگلیسی و فارسی',
      subtitle: 'تمام پروژه‌ها با رعایت سخت‌گیرانه‌ترین استانداردهای سرعت، سئو، ریسپانسیو و رابط کاربری مدرن پیاده‌سازی شده‌اند.',
      filterAll: 'همه پروژه‌ها',
      filterCustom: 'کدنویسی اختصاصی (React/Next)',
      filterWordpress: 'وردپرس و ووکامرس',
      filterTypo3: 'تایپو ۳ سازمانی (TYPO3)',
      filterJoomla: 'جوملا (Joomla)',
      filterEcommerce: 'فروشگاه‌های اینترنتی',
      viewLivePreview: 'مشاهده جزئیات و بررسی فنی',
      liveDemo: 'دموی زنده / بررسی پروژه',
      speedScore: 'امتیاز سرعت',
      seoScore: 'امتیاز سئو',
      loadTime: 'زمان لود',
      keyImpact: 'دستاورد پروژه',
      architecture: 'معماری فنی',
      keyFeatures: 'ویژگی‌های کلیدی',
      interactiveScrollHint: 'برای مشاهده سایر پروژه‌ها به چپ و راست اسکرول کنید یا روی هر پروژه کلیک کنید',
      showGrid: 'نمایش شبکه‌ای',
      showCarousel: 'نمایش اسلایدر متحرک',
    },
    calculator: {
      sectionBadge: 'محاسبه‌گر شفاف قیمت و زمان',
      title: 'تخمین آنلاین هزینه و زمان تحویل پروژه شما',
      subtitle: 'با انتخاب مشخصات فنی مورد نظر، بلافاصله هزینه تخمینی، زمان تحویل و گارانتی پشتیبانی را مشاهده کنید.',
      step1: '۱. نوع متدولوژی و تکنولوژی توسعه:',
      step2: '۲. نوع کاربری و مقیاس پروژه:',
      step3: '۳. امکانات و ماژول‌های تکمیلی:',
      customDev: 'کدنویسی اختصاصی (React/Next.js/Node)',
      wpDev: 'وردپرس اختصاصی (WordPress / WooCommerce)',
      typo3Dev: 'تایپو ۳ سازمانی (TYPO3 Enterprise)',
      joomlaDev: 'جوملا حرفه‌ای (Joomla CMS)',
      scopeCorporate: 'سایت شرکتی و معرفی خدمات',
      scopeEcommerce: 'فروشگاه آنلاین پیشرفته با درگاه پرداخت',
      scopeEnterprise: 'پورتال سازمانی چندزبانه با سطوح دسترسی',
      scopeStartup: 'سامانه استارتاپی و وب‌اپلیکیشن اختصاصی',
      featMultilingual: 'پشتیبانی کامل از ۲ یا چند زبان (EN/FA)',
      featSpeed99: 'بسته سرعت فرابنفش (لود زیر ۱ ثانیه و Core Web Vitals)',
      featSchemaSeo: 'پکیج کامل سئو تکنیکال (Robots.txt, Sitemap.xml, Schemas)',
      featCustomAdmin: 'پنل مدیریت اختصاصی با گزارش‌گیری هوشمند',
      featPaymentPwa: 'اپلیکیشن تحت وب PWA و درگاه‌های پرداخت شتابی و ارزی',
      featAiAssistant: 'یکپارچه‌سازی دستیار گفتگوی هوش مصنوعی (AI)',
      resultTitle: 'خلاصه تخمین پروژه شما:',
      estimatedCostToman: 'هزینه تخمینی (تومان):',
      estimatedCostUsd: 'معادل ارزی (USD):',
      estimatedTimeline: 'زمان تقریبی تحویل:',
      days: 'روز کاری',
      includedFree: 'شامل رایگان در تمام پکیج‌های سورنا آی‌تی:',
      includedItems: [
        'طراحی ۱۰۰٪ ریسپانسیو و بهینه برای موبایل و تبلت',
        'ساخت خودکار فایل‌های Robots.txt و Sitemap.xml',
        'پیاده‌سازی متاتگ‌ها، متادسکریپشن و صفت Alt سئو تصاویر',
        'تزریق اسکیماهای استاندارد Organization و ProfessionalService',
        '۶ ماه پشتیبانی فنی و امنیتی رایگان ۲۴/۷',
        'آموزش ویدئویی کامل مدیریت محتوای سایت',
      ],
      orderThisPlan: 'ثبت سفارش با این مشخصات و دریافت تخفیف مشاوره',
    },
    techComparison: {
      sectionBadge: 'راهنمای انتخاب هوشمندانه',
      title: 'مقایسه جامع: کدنویسی اختصاصی vs وردپرس vs تایپوتری vs جوملا',
      subtitle: 'سورنا آی‌تی توانایی اجرای هر ۴ بستر را دارد؛ جدول زیر به شما کمک می‌کند مناسب‌ترین بستر را برای کسب‌وکار خود انتخاب کنید.',
      criteria: 'معیار بررسی',
      customCol: 'کدنویسی اختصاصی',
      wpCol: 'وردپرس (WordPress)',
      typo3Col: 'تایپو ۳ (TYPO3)',
      joomlaCol: 'جوملا (Joomla)',
      speed: 'سرعت و عملکرد خام',
      security: 'امنیت در برابر حملات',
      scalability: 'مقیاس‌پذیری و حجم دیتا',
      easeOfUse: 'سهولت کاربری مدیر سایت',
      maintenance: 'هزینه نگهداری دوره‌ای',
      bestFor: 'بهترین کاربرد برای',
      showDetails: 'مشاهده نقاط قوت و ضعف',
    },
    seoCenter: {
      sectionBadge: 'شفافیت و استانداردهای سئو',
      title: 'معماری فنی سئو، نقشه سایت XML و فایل Robots.txt',
      subtitle: 'ما در sorena-it.ir تمامی قواعد سئو گوگل را از پایه‌ای‌ترین لایه‌های کد تا پیشرفته‌ترین ساختارها پیاده‌سازی می‌کنیم.',
      tabRobots: 'فایل Robots.txt واقعی',
      tabSitemap: 'نقشه سایت Sitemap.xml',
      tabSchema: 'اسکیماهای Schema.org (JSON-LD)',
      tabMetaRules: 'قوانین متا و متادسکریپشن',
      copyCode: 'کپی کد استاندارد',
      copied: 'کپی شد!',
      testLiveUrl: 'بررسی آدرس زنده فایل در سرور',
      robotsDesc: 'فایل ربات به موتورهای جستجو مسیر صحیح خزش را نشان داده و بخش‌های امنیتی یا خصوصی را مسدود می‌کند.',
      sitemapDesc: 'نقشه سایت ساختار صفحات، اولویت‌ها (Priority)، تاریخ آخرین به‌روزرسانی و پیوندهای چندزبانه را برای ایندکس سریع معرفی می‌کند.',
      schemaDesc: 'کدهای ساختاریافته JSON-LD به گوگل کمک می‌کند تا هویت سورنا آی‌تی، خدمات، محدوده جغرافیایی و قیمت‌ها را در نتایج ستاره‌دار و ریچ‌اسنیپت نمایش دهد.',
      metaDesc: 'تمام صفحات دارای تگ‌های OpenGraph، Twitter Card، تگ کنونیکال (Canonical)، متادسکریپشن دقیق و متن جایگزین (Alt) بهینه برای تصاویر هستند.',
    },
    whyUs: {
      sectionBadge: 'مزیت‌های رقابتی ما',
      title: 'چرا سازمان‌ها و برندها سورنا آی‌تی را انتخاب می‌کنند؟',
      item1Title: 'کدنویسی بدون کثیف‌کاری و بدون قالب آماده سنگین',
      item1Desc: 'تمام قالب‌ها و کامپوننت‌ها از صفر با استاندارد Clean Code و کامنت‌گذاری کامل ساخته می‌شوند.',
      item2Title: 'سرعت فرابنفش و امتیاز بالای ۹۵ در گوگل لایت‌هاوس',
      item2Desc: 'لود سریعتر مساوی با نرخ تبدیل بالاتر و رضایت کاربران در تمام اینترنت‌های پرسرعت و کم‌سرعت.',
      item3Title: 'تسلط کامل بر تمام CMSهای معتبر جهانی',
      item3Desc: 'تنها آژانسی که به صورت تخصصی پروژه‌های TYPO3 Enterprise، Joomla، WordPress و React را در سطح بین‌المللی اجرا می‌کند.',
      item4Title: 'سئو تکنیکال از خشت اول',
      item4Desc: 'تزریق اتوماتیک اسکیما، ساختار آدرس‌دهی تمیز، نقشه سایت چندزبانه و سازگاری کامل با الگوریتم‌های هوش مصنوعی گوگل.',
      item5Title: 'قرارداد رسمی با SLA و پشتیبانی ۲۴/۷',
      item5Desc: 'پشتیبانی فنی بی‌وقفه، گارانتی بازگشت وجه در صورت عدم تطابق با پروپوزال و آموزش صفر تا صد تیم شما.',
      item6Title: 'معماری چندزبانه بی‌نقص',
      item6Desc: 'پشتیبانی همزمان از زبان‌های RTL مانند فارسی/عربی و زبان‌های LTR مانند انگلیسی/آلمانی با سوئیچ سریع.',
    },
    testimonials: {
      sectionBadge: 'نظرات کارفرمایان',
      title: 'تجربه همکاری با تیم مهندسی سورنا آی‌تی',
      subtitle: 'دیدگاه مدیران شرکت‌ها، فروشگاه‌ها و موسساتی که طراحی و سئوی سایت خود را به ما سپردند.',
    },
    faq: {
      sectionBadge: 'پاسخ به سوالات شما',
      title: 'سوالات متداول درباره طراحی سایت و سئو',
      subtitle: 'هر آنچه درباره نحوه سفارش، انتخاب تکنولوژی، سئو و پشتیبانی باید بدانید.',
    },
    contact: {
      sectionBadge: 'شروع همکاری و مشاوره',
      title: 'درخواست مشاوره تخصصی و ثبت سفارش پروژه',
      subtitle: 'فرم زیر را پر کنید تا کارشناسان ارشد فنی سورنا آی‌تی حداکثر ظرف ۲ ساعت کاری با شما تماس بگیرند یا مستقیماً از طریق واتساپ و تلگرام پیام دهید.',
      nameLabel: 'نام و نام خانوادگی یا نام شرکت *',
      namePlaceholder: 'مثال: مهندس کاویانی / شرکت فناوری آریا',
      phoneLabel: 'شماره تماس مستقیم *',
      phonePlaceholder: '(+98)9128634908',
      emailLabel: 'آدرس ایمیل',
      emailPlaceholder: 'name@example.com',
      techLabel: 'تکنولوژی یا CMS مدنظر',
      techPlaceholder: 'انتخاب کنید...',
      scopeLabel: 'نوع پروژه',
      budgetLabel: 'بودجه تقریبی در نظر گرفته شده',
      messageLabel: 'توضیحات و نیازمندی‌های پروژه *',
      messagePlaceholder: 'لطفاً مختصری درباره اهداف سایت، امکانات درخواستی و زمان‌بندی مدنظر بنویسید...',
      submitBtn: 'ارسال درخواست و گفتگو در واتساپ',
      submitting: 'در حال ثبت و انتقال به واتساپ...',
      directChatTitle: 'ارتباط مستقیم و فوری:',
      whatsapp: 'گفتگو در واتساپ',
      telegram: 'ارتباط در تلگرام',
      phoneCall: 'تماس تلفنی مستقیم',
      officeAddress: 'البرز - کرج - ۴۵ متری گلشهر - بالای بانک اقتصاد نوین - واحد ۱',
      landlinePhones: 'تلفن ثابت: ۰۲۶۳۳۵۰۴۷۷۵ - ۰۲۶۳۳۵۰۴۷۷۲',
      landline1: '02633504775',
      landline2: '02633504772',
      websiteUrl: 'وب‌سایت رسمی: sorena-it.ir',
      emailAddress: 'پست الکترونیک: info@sorena-it.ir / sales@sorena-it.ir',
      workingHours: 'ساعات کاری: شنبه تا پنجشنبه از ۸:۳۰ الی ۱۹:۰۰',
      successMessage: 'درخواست شما ثبت و در حال انتقال به واتساپ به شماره (+98)9128634908 است.',
    },
    algoTrading: {
      sectionBadge: 'برنامه‌نویسی اختصاصی فارکس و بازارهای مالی',
      title: 'تبدیل ۱۰۰٪ استراتژی‌های معاملاتی به کد MQL5 و Pine Script',
      subtitle: 'توسعه تخصصی اکسپرت‌های اتوماتیک متاتریدر ۵ (MQ5)، اندیکاتورها و استراتژی‌های پیشرفته تریدینگ‌ویو (Pine Script v5) همراه با سیستم‌های مدیریت ریسک پاس کردن چالش‌های پراپ فرم و اتصال وب‌هوک.',
      tabOverview: 'معماری و خدمات فارکس',
      tabStrategies: 'نمونه اکسپرت‌ها و ربات‌ها',
      tabCodeDemo: 'سورس‌کد و ساختار فنی',
      tabPropGuards: 'سپر محافظتی پراپ فرم',
      tabWorkflow: 'مراحل ۵ گانه تبدیل ایده به کد',
      tabCalculator: 'محاسبه‌گر پروژه فارکس',
      mql5Title: 'برنامه‌نویسی اکسپرت متاتریدر ۵ (MQL5 / MQ5)',
      mql5Desc: 'توسعه ربات‌های تمام اتوماتیک اسکلپ، سویینگ، دستیارهای نیمه اتوماتیک معامله‌گر، کنترل لحظه‌ای اسپرد و اسلیپیج با بالاترین سرعت اجرای اردر.',
      pineTitle: 'کدنویسی استراتژی و اندیکاتور TradingView (Pine Script v5)',
      pineDesc: 'طراحی پیشرفته‌ترین اندیکاتورهای پرایس اکشن (ICT, SMC, RTM)، آلارم‌های دقیق، ساختار چند تایم‌فریمی و خروجی JSON وب‌هوک.',
      bridgeTitle: 'سیستم وب‌هوک و پل ارتباطی تریدینگ‌ویو به متاتریدر',
      bridgeDesc: 'اتصال خودکار آلارم‌های تریدینگ‌ویو به متاتریدر ۵ و صرافی‌های کریپتو با تاخیر زیر ۵۰ میلی‌ثانیه و محاسبه خودکار لات بر اساس ریسک.',
      riskTitle: 'ماژول‌های هوشمند رعایت قوانین پراپ فرم (Prop Firm Guard)',
      riskDesc: 'سیستم‌های قطع خودکار معاملات (Kill Switch)، قفل دراودان روزانه و کل برای حفظ اکانت‌های FTMO، FundedNext و پراپ‌های معتبر.',
      orderCustomBot: 'سفارش تبدیل استراتژی معاملاتی به کد',
      consultBot: 'مشاوره اختصاصی با مهندس آرش کاویانی‌پور',
      openSourceGuarantee: 'ضمانت تحویل ۱۰۰٪ سورس‌کد باز و بدون قفل',
      vpsReady: 'آماده استقرار و کارکرد ۲۴/۷ روی سرور مجازی (VPS)',
      backtestQuality: 'بک‌تست عمیق با دیتای کیفیت ۹۹.۹٪ تیک واقعی',
      propCompliant: 'منطبق بر قوانین چالش‌های پراپ فرم بین‌المللی',
    },
    executiveProfile: {
      sectionBadge: 'سوابق و پروفایل رسمی مدیریت',
      title: 'مهندس آرش کاویانی‌پور — برنامه‌نویس، متخصص ارشد وردپرس و مدرس',
      roleTitle: 'Programmer | WordPress Expert & Senior Plugin Specialist',
      currentPositions: [
        'مالک و بنیان‌گذار وب‌سایت sorena-it.com و sorena-it.ir',
        'مدرس ارشد طراحی وب‌سایت به‌صورت از راه دور (Senior Remote Web Design Instructor)',
        'توسعه‌دهنده ارشد افزونه‌های اختصاصی وردپرس و وب‌اپلیکیشن‌های پیشرفته',
        'متخصص بازارهای مالی و برنامه‌نویسی ربات‌های الگوریتمی فارکس (MQL5 / Pine Script)',
      ],
      bioSummary: 'فارغ‌التحصیل فوق لیسانس مهندسی نرم‌افزار. با بیش از ۱۲ سال سابقه کار حرفه‌ای در حوزه طراحی و توسعه وب‌سایت از سال ۱۳۹۳ (2014)، مدیریت فنی و عملیات شرکت‌های معتبری از جمله بروکر والفاینر (Walfiner Broker) و آکادمی ژرف‌گستر را بر عهده داشته‌ام. به عنوان بنیان‌گذار سورنا، خدمات خلاقانه و پیشرفته طراحی وب ارائه می‌دهم و تسلط روان به زبان آلمانی در کنار تجربه تدریس، امکان تعاملات بین‌المللی موثر را برای من فراهم کرده است. علاوه بر توسعه وب، در بازارهای مالی تخصص داشته و در حوزه الگوریتمیک تریدینگ و ربات‌های فارکس راه‌حل‌های هوشمندانه ارائه می‌نمایم.',
      forexManagement: '۲ سال سابقه مدیریت اجرایی و زیرساخت فنی بروکر بین‌المللی فارکس (Walfiner Broker)',
      remoteTeaching: 'در حال حاضر مدرس ارشد طراحی سایت به‌صورت از راه دور (تدریس به دانشجویان داخل و خارج از کشور)',
      germanFluency: 'تسلط کامل و روان به زبان آلمانی همراه با سابقه تدریس و همکاری‌های فنی بین‌المللی',
      seoExperience: 'متخصص سئو با ۴ سال سابقه حرفه‌ای متمرکز در بهینه‌سازی موتورهای جستجو، سئو تکنیکال، استراتژی‌های On-Page و Off-Page',
      googleCert: 'دارای مدرک رسمی بین‌المللی Google Digital Marketing & E-commerce Professional Certificate (2024)',
      education: 'فوق لیسانس (کارشناسی ارشد) مهندسی نرم‌افزار',
      careerHighlights: [
        {
          year: '2014 – اکنون (+12 سال)',
          title: 'بنیان‌گذار و مالک وب‌سایت — سورنا آی‌تی (sorena-it.com / sorena-it.ir)',
          desc: 'طراحی، معماری و پیاده‌سازی بیش از ۱۵۰ پورتال سازمانی، سامانه‌های اختصاصی React/Next.js، افزونه‌های پیشرفته وردپرس و وب‌سایت‌های چندزبانه بین‌المللی.',
        },
        {
          year: 'موقعیت فعلی',
          title: 'مدرس ارشد طراحی وب‌سایت (به‌صورت از راه دور)',
          desc: 'تدریس تخصصی متدولوژی‌های مدرن فرانت‌اند، توسعه پلاگین‌های سفارشی وردپرس، معماری سئو و استانداردهای Core Web Vitals.',
        },
        {
          year: '۲ سال مدیریت',
          title: 'مدیر عملیات و زیرساخت فنی بروکر فارکس (Walfiner Broker)',
          desc: 'مدیریت ارشد عملیاتی بروکر، مدیریت سرورهای متاتریدر، سامانه‌های وب‌هوک و امنیت حساب‌ها و الگوریتم‌های معاملاتی.',
        },
        {
          year: 'سوابق سازمانی',
          title: 'مدیریت عملیات فنی در شرکت ام‌گاز (M-Gas) و آکادمی ژرف‌گستر',
          desc: 'هدایت تیم‌های نرم‌افزاری، پیاده‌سازی پورتال‌های سازمانی و اتوماسیون فرآیندهای دیجیتال.',
        },
      ],
      keySkills: [
        'Senior WordPress Plugin Development & Customization',
        'Web Design & WordPress Development (Expert Level)',
        'Programming and Technical Development (TypeScript, React, Next.js, Node.js)',
        'Algorithmic Trading & Forex Robots (MQL5 / Pine Script)',
        'SEO Specialist (4 Years Dedicated Technical SEO)',
        'Google Digital Marketing & E-commerce Certified (2024)',
        'Senior Remote Web Design Instructor',
        'German Language Fluency & International Collaborations',
      ]
    },
    footer: {
      about: 'شرکت مهندسی سورنا آی‌تی (sorena-it.com / sorena-it.ir) ارائه‌دهنده راهکارهای جامع طراحی و برنامه‌نویسی انواع وب‌سایت‌های مدرن، وب‌اپلیکیشن‌های پیشرفته و سیستم‌های سازمانی وردپرس، تایپوتری و جوملا با استانداردهای بین‌المللی سئو و سرعت.',
      quickLinks: 'دسترسی سریع',
      servicesLinks: 'خدمات طراحی وب',
      seoResources: 'منابع سئو و فایل‌ها',
      rights: 'تمامی حقوق مادی و معنوی این وب‌سایت متعلق به مهندس آرش کاویانی‌پور و مجموعه سورنا آی‌تی (sorena-it.com / sorena-it.ir) می‌باشد.',
      designedWith: 'طراحی شده با استانداردهای سئو تکنیکال، React 19 و معماری مدرن وب.',
    },
  },
  en: {
    meta: {
      siteName: 'Sorena IT',
      domain: 'sorena-it.com / sorena-it.ir',
      tagline: 'Premier Web Design & Engineering: Bespoke Code, WordPress, TYPO3 & Joomla',
    },
    nav: {
      services: 'Services',
      campaign: '$1,000 to $300 Campaign',
      algoTrading: 'Forex Algo (MQ5 / Pine)',
      portfolio: 'Portfolio Showcase',
      techComparison: 'Tech Comparison',
      calculator: 'Cost & Time Calculator',
      seoCenter: 'SEO & Standard Files',
      blog: 'SEO & Tech Articles',
      whyUs: 'Why Sorena IT?',
      faq: 'FAQ',
      contact: 'Contact & Order',
      requestQuote: 'Instant Quote',
      callUs: 'Call: (+98)9128634908',
    },
    hero: {
      badge: 'Modern Web Architecture & Engineering Hub',
      title1: 'Modern Bespoke Web Design',
      title2: 'Custom Code, WordPress, TYPO3 & Joomla',
      description: 'Sorena IT (sorena-it.ir) engineers high-performance web applications, enterprise portals, and eCommerce ecosystems leveraging React, Next.js, Node.js, alongside enterprise CMS solutions (WordPress, TYPO3, Joomla) with sub-second load times and 100% Core Web Vitals.',
      ctaPrimary: 'Calculate Project Cost Online',
      ctaSecondary: 'Explore Scrollable Showcase',
      speedMetric: 'Core Web Vitals Score',
      speedValue: '100% Ultra Fast',
      seoMetric: 'Google Schema & SEO Compliance',
      seoValue: 'Rank #1 Guaranteed',
      satisfactionMetric: 'Client Satisfaction Rate',
      satisfactionValue: '99.4% Rated',
      techTickerTitle: 'Architecting websites across modern stacks & CMS platforms:',
    },
    services: {
      sectionBadge: 'Our Core Engineering Capabilities',
      title: 'World-Class Web Development on Any Platform',
      subtitle: 'Whether you require a custom full-stack React application, an enterprise TYPO3 portal, a streamlined WordPress WooCommerce shop, or a secure Joomla platform, we engineer perfection.',
      customTitle: 'Bespoke Custom Web Development',
      customBadge: 'High Performance & Scale',
      customDesc: 'Full-stack custom applications built from scratch using React 19, Next.js, Node.js, Python FastAPI, and Tailwind CSS. Clean, zero-bloat modular architecture.',
      wordpressTitle: 'Custom WordPress & WooCommerce',
      wordpressBadge: 'Custom Themes & Speed',
      wordpressDesc: 'Tailored themes coded from the ground up without heavy pre-made builders, custom plugins, and sub-second WooCommerce e-commerce engineering.',
      typo3Title: 'TYPO3 Enterprise CMS Development',
      typo3Badge: 'Enterprise & Security',
      typo3Desc: 'Institutional & government-grade multilingual portals with military-grade permissions, multi-domain governance, and bulletproof security.',
      joomlaTitle: 'Joomla CMS Portals & Solutions',
      joomlaBadge: 'Robust CMS Architecture',
      joomlaDesc: 'Scalable corporate portals, community directories, and customized extensions built on the latest Joomla architecture.',
      seoTitle: 'Technical SEO, Schema & Sitemap Engine',
      seoBadge: 'Rank #1 Google Standards',
      seoDesc: 'Flawless robots.txt generation, multilingual XML sitemaps, JSON-LD rich snippets (Organization, Product, FAQ), meta descriptions, and image alt optimization.',
      uiuxTitle: 'UI/UX & Interactive Product Design',
      uiuxBadge: 'Human-Centered Design',
      uiuxDesc: 'Bespoke Figma design systems, responsive mobile-first interfaces, micro-interactions, and high-conversion user journey mapping.',
      viewDetails: 'View Technical Details & Specs',
    },
    portfolio: {
      sectionBadge: 'Scrollable Showcase & Case Studies',
      title: 'Curated Web Portfolios & Live Showcase',
      subtitle: 'Explore our latest international and enterprise web creations, engineered for blistering speed, top SEO ranking, and stellar UX.',
      filterAll: 'All Projects',
      filterCustom: 'Custom Code (React/Next)',
      filterWordpress: 'WordPress / WooCommerce',
      filterTypo3: 'TYPO3 Enterprise',
      filterJoomla: 'Joomla CMS',
      filterEcommerce: 'E-Commerce Platforms',
      viewLivePreview: 'Inspect Case Study & Specs',
      liveDemo: 'Live Demo / Audit',
      speedScore: 'Speed Score',
      seoScore: 'SEO Score',
      loadTime: 'Load Time',
      keyImpact: 'Key Impact',
      architecture: 'Technical Stack',
      keyFeatures: 'Core Capabilities',
      interactiveScrollHint: 'Scroll horizontally to explore projects or click on any card for full architecture overview',
      showGrid: 'Grid View',
      showCarousel: 'Scrollable Showcase',
    },
    calculator: {
      sectionBadge: 'Transparent Pricing Engine',
      title: 'Instant Online Project Cost & Timeline Estimator',
      subtitle: 'Configure your technical scope to receive an immediate transparent estimation of investment, timeline, and SLA guarantees.',
      step1: '1. Select Technology & Development Methodology:',
      step2: '2. Select Project Scope & Scale:',
      step3: '3. Add Optional Features & Modules:',
      customDev: 'Bespoke Code (React / Next.js / Node.js)',
      wpDev: 'Custom WordPress / WooCommerce',
      typo3Dev: 'TYPO3 Enterprise CMS Portal',
      joomlaDev: 'Joomla CMS Portal Solution',
      scopeCorporate: 'Corporate & Services Website',
      scopeEcommerce: 'Advanced E-Commerce with Payment Gateways',
      scopeEnterprise: 'Enterprise Multi-Role & Multilingual Portal',
      scopeStartup: 'Startup SaaS Platform & Web Application',
      featMultilingual: 'Full Multilingual Support (EN / FA / DE / AR)',
      featSpeed99: 'Ultra-Performance Pack (Sub-second load & Core Web Vitals)',
      featSchemaSeo: 'Full Technical SEO Suite (Robots.txt, Sitemap, Schema.org)',
      featCustomAdmin: 'Custom Analytics Dashboard & Admin Control',
      featPaymentPwa: 'PWA Web App & Global/Local Payment Integrations',
      featAiAssistant: 'Integrated AI Customer Service & Chatbot',
      resultTitle: 'Estimated Investment Breakdown:',
      estimatedCostToman: 'Estimated Cost (IRR Toman):',
      estimatedCostUsd: 'Estimated Cost (USD):',
      estimatedTimeline: 'Estimated Delivery Time:',
      days: 'Working Days',
      includedFree: 'Complimentary in all Sorena IT Packages:',
      includedItems: [
        '100% Mobile-first responsive UX across all screen sizes',
        'Automatic Robots.txt and XML Sitemap generation',
        'Complete Meta tags, meta descriptions, and image alt attributes',
        'Google Schema.org rich snippet injection (Organization & Service)',
        '6 Months of free 24/7 technical and security support',
        'Complete HD video training for CMS content management',
      ],
      orderThisPlan: 'Book Project with these Specifications',
    },
    techComparison: {
      sectionBadge: 'Architectural Guide',
      title: 'In-Depth Comparison: Custom Code vs WordPress vs TYPO3 vs Joomla',
      subtitle: 'Sorena IT provides mastery across all four ecosystems. Use this matrix to match your business goals with the right architecture.',
      criteria: 'Evaluation Metric',
      customCol: 'Custom Code',
      wpCol: 'WordPress',
      typo3Col: 'TYPO3 CMS',
      joomlaCol: 'Joomla CMS',
      speed: 'Raw Speed & Performance',
      security: 'Security & Vulnerability Defense',
      scalability: 'Scalability & Data Volume',
      easeOfUse: 'Content Editor Ease of Use',
      maintenance: 'Ongoing Maintenance Cost',
      bestFor: 'Ideal For',
      showDetails: 'View Detailed Pros & Cons',
    },
    seoCenter: {
      sectionBadge: 'SEO & Code Transparency',
      title: 'SEO Architecture, XML Sitemaps & Robots.txt Center',
      subtitle: 'At sorena-it.ir, we enforce Google Search algorithms and Core Web Vitals from the foundational layer of code.',
      tabRobots: 'Production Robots.txt',
      tabSitemap: 'Bilingual Sitemap.xml',
      tabSchema: 'Schema.org (JSON-LD)',
      tabMetaRules: 'Meta & Description Rules',
      copyCode: 'Copy Standard Code',
      copied: 'Copied!',
      testLiveUrl: 'Test Live File on Server',
      robotsDesc: 'Robots.txt directs search bot crawlers to indexing targets while shielding sensitive API and admin endpoints.',
      sitemapDesc: 'The XML Sitemap outlines URL hierarchy, priority weights, last modification timestamps, and hreflang translations.',
      schemaDesc: 'JSON-LD structured data guarantees rich snippets, star ratings, and knowledge panel recognition on Google Search.',
      metaDesc: 'Every page features optimized canonical tags, social OpenGraph/Twitter cards, high-converting meta descriptions, and descriptive image alt tags.',
    },
    whyUs: {
      sectionBadge: 'Competitive Advantage',
      title: 'Why Top Organizations Partner with Sorena IT',
      item1Title: 'Zero-Bloat, Clean-Code Architecture',
      item1Desc: 'We do not sell slow, bloated templates. Every module is meticulously hand-crafted with modular precision.',
      item2Title: 'Sub-Second Loading & 95+ Lighthouse Score',
      item2Desc: 'Blazing speed directly converts into higher Google search rankings and elevated conversion rates.',
      item3Title: 'Multi-Stack CMS & Custom Code Mastery',
      item3Desc: 'We are one of the rare agencies delivering world-class TYPO3, Joomla, WordPress, and React at enterprise standards.',
      item4Title: 'Technical SEO Baked in from Day One',
      item4Desc: 'Automatic schema markup, semantic HTML5, multilingual hreflang, and AI search engine readiness.',
      item5Title: 'Formal Contract with SLA & 24/7 Support',
      item5Desc: 'Guaranteed delivery dates, money-back scope guarantee, and continuous post-launch support.',
      item6Title: 'Flawless Dual-Language & RTL/LTR Switch',
      item6Desc: 'Seamless bidirectional layouts supporting both Persian/Arabic (RTL) and English/European (LTR) typography.',
    },
    testimonials: {
      sectionBadge: 'Client Success Stories',
      title: 'Trusted by Businesses, Institutions & Startups',
      subtitle: 'Read direct feedback from executives who transformed their digital presence with Sorena IT.',
    },
    faq: {
      sectionBadge: 'Frequently Asked Questions',
      title: 'Got Questions? We Have Answers',
      subtitle: 'Everything you need to know about our web engineering process, technology stacks, SEO, and support.',
    },
    contact: {
      sectionBadge: 'Start Your Project',
      title: 'Request a Consultation & Project Quotation',
      subtitle: 'Fill out the form below to receive a detailed proposal within 2 business hours, or message us directly on WhatsApp & Telegram.',
      nameLabel: 'Full Name / Company Name *',
      namePlaceholder: 'e.g. Arash Kavian / Aria Tech Solutions',
      phoneLabel: 'Direct Phone Number *',
      phonePlaceholder: '(+98)9128634908',
      emailLabel: 'Email Address',
      emailPlaceholder: 'name@example.com',
      techLabel: 'Preferred Technology or CMS',
      techPlaceholder: 'Select an option...',
      scopeLabel: 'Project Type',
      budgetLabel: 'Estimated Budget Range',
      messageLabel: 'Project Details & Requirements *',
      messagePlaceholder: 'Please tell us about your goals, requested features, and target timeline...',
      submitBtn: 'Submit Inquiry & Chat on WhatsApp',
      submitting: 'Submitting & Connecting to WhatsApp...',
      directChatTitle: 'Direct & Immediate Contact:',
      whatsapp: 'Chat on WhatsApp',
      telegram: 'Connect on Telegram',
      phoneCall: 'Direct Phone',
      officeAddress: 'Unit 1, Above Eghtesad Novin Bank, 45-Metri Golshahr, Karaj, Alborz, Iran',
      landlinePhones: 'Landline: (+98)26-33504775 / (+98)26-33504772',
      landline1: '02633504775',
      landline2: '02633504772',
      websiteUrl: 'Official Domain: sorena-it.ir',
      emailAddress: 'Email: info@sorena-it.ir / sales@sorena-it.ir',
      workingHours: 'Working Hours: Sat - Thu from 08:30 to 19:00 (GMT+3:30)',
      successMessage: 'Your inquiry has been recorded and opening WhatsApp for direct communication.',
    },
    algoTrading: {
      sectionBadge: 'Algorithmic Trading & Quantitative Development',
      title: '100% Strategy-to-Code: MQL5 (MQ5) & Pine Script v5',
      subtitle: 'Expert development of automated MetaTrader 5 Expert Advisors (EAs), custom TradingView Pine Script indicators, Prop Firm risk management safeguards, and ultra-fast webhook bridges.',
      tabOverview: 'Core Algo Capabilities',
      tabStrategies: 'Featured EAs & Indicators',
      tabCodeDemo: 'Source Code Architecture',
      tabPropGuards: 'Prop Firm Risk Guards',
      tabWorkflow: '5-Step Conversion Process',
      tabCalculator: 'Algo Cost Estimator',
      mql5Title: 'MetaTrader 5 Expert Advisor Development (MQL5)',
      mql5Desc: 'Fully automated scalpers, swing algorithms, semi-automated trading assistants, tick-level execution, and dynamic spread & slippage control.',
      pineTitle: 'TradingView Pine Script v5 Indicators & Strategies',
      pineDesc: 'Institutional order flow (ICT, SMC, Fair Value Gaps), multi-timeframe structures, and automated JSON webhook execution pipelines.',
      bridgeTitle: 'TradingView-to-MT5 Webhook Bridge',
      bridgeDesc: 'Automated relay routing TradingView alerts to live MetaTrader 5 and crypto accounts with sub-50ms latency and dynamic lot sizing.',
      riskTitle: 'Prop Firm Challenge Risk Management Guards',
      riskDesc: 'Automatic kill switch, max daily loss protector, and equity preservation algorithms tailored for FTMO, FundedNext, and top prop firms.',
      orderCustomBot: 'Order Strategy-to-Code Conversion',
      consultBot: 'Book Strategy Consultation with Arash Kavianipoor',
      openSourceGuarantee: '100% Unlocked Source Code Handover',
      vpsReady: 'VPS 24/7 Deployment & High Uptime Architecture',
      backtestQuality: '99.9% Real Tick Data Backtesting & Stress-Testing',
      propCompliant: 'Strict Prop Firm Risk Compliant Logic',
    },
    executiveProfile: {
      sectionBadge: 'Executive Profile & Credentials',
      title: 'Eng. Arash Kavianipoor — Programmer, WordPress Expert & Senior Instructor',
      roleTitle: 'Programmer | WordPress Expert & Senior Plugin Specialist',
      currentPositions: [
        'Founder & Owner of sorena-it.com & sorena-it.ir',
        'Senior Remote Web Design Instructor & Technical Mentor',
        'Senior WordPress Plugin Architect & Scalable Web Application Engineer',
        'Financial Quantitative Programmer (MQL5 & Pine Script Expert Advisors)',
      ],
      bioSummary: 'I am Arash Kavianipoor, holder of a Master of Science (M.Sc.) in Software Engineering. With over 12 years of professional experience in web design and development since 2014, I have managed technical operations for well-known companies, including Walfiner Broker and Jarfgostar Academy. As the founder and owner of Sorena (sorena-it.com & sorena-it.ir), I provide innovative bespoke web design and development services. My fluency in German, combined with my teaching experience, has enabled me to establish effective international communication and collaborations. In addition to web development, I am actively involved in financial markets, specializing in algorithmic trading and Forex robots, where I combine technical expertise with creative problem-solving to deliver intelligent trading solutions.',
      forexManagement: '2 Years of Executive Forex Broker Management & Technical Operations (Walfiner Broker)',
      remoteTeaching: 'Currently Senior Remote Web Design Instructor teaching modern engineering, plugin development & technical SEO',
      germanFluency: 'Fluent German (Deutsch C1 / Professional) with extensive international collaboration and teaching track record',
      seoExperience: 'SEO Specialist with 4 years of dedicated professional experience in Search Engine Optimization, technical SEO, on-page and off-page strategies',
      googleCert: 'Google Digital Marketing & E-commerce Professional Certificate (2024)',
      education: 'Master of Science (M.Sc.) in Software Engineering',
      careerHighlights: [
        {
          year: '2014 – Present (12+ Yrs)',
          title: 'Founder & Owner — Sorena IT (sorena-it.com / sorena-it.ir)',
          desc: 'Architected and delivered over 150+ custom React/Next.js platforms, WordPress plugin solutions, enterprise TYPO3 portals, and multilingual global projects.',
        },
        {
          year: 'Current Position',
          title: 'Senior Remote Web Design Instructor & Mentor',
          desc: 'Instructing modern frontend frameworks, bespoke WordPress plugin engineering, Google Core Web Vitals optimization, and enterprise architecture remotely.',
        },
        {
          year: '2 Years Management',
          title: 'Operations & Technical Director at International Forex Broker (Walfiner Broker)',
          desc: 'Executive management of Forex brokerage operations, MetaTrader server infrastructure, webhook liquidity pipelines, and quantitative risk management.',
        },
        {
          year: 'Enterprise Roles',
          title: 'Technical Operations Management at M-Gas & Jarfgostar Academy',
          desc: 'Led software development teams, enterprise portal rollouts, and institutional digitalization pipelines.',
        },
      ],
      keySkills: [
        'Web Design & WordPress Development (Expert Level)',
        'Senior WordPress Plugin Development & Customization',
        'Programming and Technical Development (TypeScript, React 19, Next.js, Node.js)',
        'Algorithmic Trading & Forex Robots (MQL5 / Pine Script v5)',
        'SEO Specialist (4+ Years Dedicated Technical & On/Off-Page SEO)',
        'Google Digital Marketing & E-commerce Professional Certificate (2024)',
        'Senior Remote Web Design Instructor',
        'Fluent German & International Engineering Collaboration',
      ]
    },
    footer: {
      about: 'Sorena IT (sorena-it.com / sorena-it.ir) is a premier digital engineering firm specializing in bespoke modern web applications, high-performance WordPress stores, enterprise TYPO3 portals, and Joomla platforms with world-class SEO standards.',
      quickLinks: 'Quick Links',
      servicesLinks: 'Web Services',
      seoResources: 'SEO Standards & Files',
      rights: 'All rights reserved © Arash Kavianipoor & Sorena IT (sorena-it.com / sorena-it.ir).',
      designedWith: 'Engineered with React 19, Technical SEO, and sub-second architecture.',
    },
  },
};
